/*
 * assets/js/src/lokality.js — mapa, filtr a posuvníky výpisu lokalit.
 *
 * SKLIZENO z `navrh-lokality.html` (tag `za-navrhy-v1.0`), inline blok
 * ~35 kB. Přenášelo se tělo, ne popis: chování je z návrhu doslova,
 * změny jsou tři a všechny jsou zapsané v DIVERGENCE.md.
 *
 * ---------------------------------------------------------------------
 * TŘI ZMĚNY PROTI NÁVRHU
 * ---------------------------------------------------------------------
 * 1. DATA NEJSOU V SOUBORU. Návrh má `var POINTS=[…]` natvrdo; tady
 *    přicházejí z PHP (`window.ZA2026_LOKALITY`) ze stejných polí, ze
 *    kterých čte `za_map_point()`. Výstup `za_map_point()` se NEMĚNÍ —
 *    čte ho plugin i administrace a jeho změna je STOP.
 * 2. TEXTY JSOU Z `za_t()`. Návrh je česky natvrdo („lokalita/lokality/
 *    lokalit", „Ve výřezu mapy:"). Anglická větev by jinak mluvila česky.
 * 3. NA MOBILU SE MAPA STAVÍ AŽ NA KLEPNUTÍ (rozhodnutí z kontraktu §2).
 *    Návrh ji inicializuje vždycky a pak jen skrývá; OpenLayers se tím
 *    stáhne a rozkreslí i čtenáři, který mapu vůbec neotevře.
 *
 * Bez knihovny `ol` modul tiše nic nedělá — stránka zůstane seznamem.
 */

/** Barvy pinů podle standardu. Z návrhu doslova. */
const PIN = { higher: '#E6D110', medium: '#ADC0C2', lower: '#00B7CD' };

/** Práh, pod kterým jsou seznam a mapa dva oddělené režimy. */
const MOBIL = '(max-width:1069px)';

function jeMobil() {
	return window.matchMedia(MOBIL).matches;
}

function pinIcon(std, hot) {
	const c = PIN[std] || PIN.medium;
	const svg =
		'<svg xmlns="http://www.w3.org/2000/svg" width="30" height="40" viewBox="0 0 28 38">' +
		'<path d="M14 36.4C5.8 25.2 2.2 20.2 2.2 14A11.8 11.8 0 0 1 25.8 14c0 6.2-3.6 11.2-11.8 22.4z" fill="' +
		c + '" stroke="' + (hot ? '#F5074C' : '#ffffff') + '" stroke-width="' + (hot ? 3.2 : 2.4) + '"/>' +
		'<circle cx="14" cy="13.6" r="4.5" fill="#ffffff"/></svg>';
	return 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
}

/** Posuvník fotek na dlaždici. Bez druhé fotky se nespouští. */
function slider(card) {
	const track = card.querySelector('.locslides');
	if (!track) return 0;
	const n = track.children.length;
	if (n < 2) return 0;
	const dots = card.querySelectorAll('.locdots i');
	let i = 0;
	const go = (k) => {
		i = (k + n) % n;
		track.style.transform = 'translateX(' + (-i * 100) + '%)';
		dots.forEach((d, j) => d.classList.toggle('on', j === i));
	};
	const p = card.querySelector('.locarr.prev');
	const x = card.querySelector('.locarr.next');
	if (p) p.addEventListener('click', (e) => { e.preventDefault(); go(i - 1); });
	if (x) x.addEventListener('click', (e) => { e.preventDefault(); go(i + 1); });
	return 1;
}

/**
 * STAVOVÝ STROJ FILTRU VÝPISU — jediné místo, kde se rozhoduje, co je vidět.
 *
 * ---------------------------------------------------------------------
 * PROČ TO NENÍ UVNITŘ `mapa()` (dávka 2e, 19. 9. 2026)
 * ---------------------------------------------------------------------
 * Do 19. 9. byl celý filtr uvnitř `mapa()` a počítal se z PINŮ (`feats`).
 * Mělo to dva důsledky, které s přibytím štítků přestaly být únosné:
 *
 * 1. BEZ MAPY FILTR NEEXISTUJE. Na mobilu se mapa staví až na klepnutí
 *    na „Mapa" (líný start, kontrakt §2). Deep link `?vlastnost=bazen`
 *    má ale filtrovat hned, i když návštěvník mapu vůbec neotevře.
 * 2. KARTA BEZ SOUŘADNIC SE NIKDY NEUKÁZALA. Pin se pro lokalitu bez
 *    `lat`/`lng` nevyrobí (`za2026_map_points_data()` ji přeskakuje),
 *    takže v `allowed` nebyla a `apply()` ji schovával pokaždé — i bez
 *    filtru. Na DEV je dnes takových lokalit 0 z 85, takže to nebylo
 *    vidět; byla to tichá vada čekající na první lokalitu bez souřadnic.
 *
 * Stav se proto počítá z KARET (`.loc` a jejich `data-*`), ne z pinů.
 * Mapa se na stroj jen věší: dostane hotový seznam povolených indexů
 * a překreslí podle něj piny, případně ho ještě zúží podle výřezu.
 *
 * Výstupní kontrakt (nesmí se pohnout, hlídá `gate:bod-k-lokality`):
 * `.loclayout.filtr-aktivni` a viditelnost „Zrušit filtr" plynou ODSUD,
 * ne z mapy — jinak by deep link bez postavené mapy filtr zapnul, ale
 * reset by se neobjevil.
 *
 * @param {object} t Texty z `window.ZA2026_LOKALITY.t`.
 * @returns {object|null} Rozhraní stroje, nebo `null`, když na stránce nejsou karty.
 */
function filtrVypisu(t) {
	const karty = [...document.querySelectorAll('.loc')];
	if (!karty.length) return null;

	const chipyTieru = [...document.querySelectorAll('.stdchip')];
	const kapacita = document.getElementById('za-capsel');
	const panel = document.getElementById('za-vlastnosti');
	const chipyVlastnosti = panel ? [...panel.querySelectorAll('button[data-vlastnost]')] : [];
	const mapcnt = document.getElementById('za-mapcnt');
	const synccnt = document.getElementById('za-synccnt');
	const empty = document.getElementById('za-empty');
	const rozvrzeni = document.querySelector('.loclayout');

	const sklonuj = (n) => {
		const tvary = (t && t.pocet) || ['lokalita', 'lokality', 'lokalit'];
		if (1 === n) return tvary[0];
		if (n >= 2 && n <= 4) return tvary[1];
		return tvary[2];
	};

	/* Slugy štítků karty. Prázdný atribut => prázdné pole, ne [''], jinak
	   by lokalita bez štítků „měla" štítek jménem prázdný řetězec. */
	const stitky = (c) => (c.dataset.stitky || '').split(' ').filter(Boolean);

	let vybrane = [];
	let povolene = {};
	const posluchaci = [];
	/* Druhá fáze: zúžení podle výřezu mapy. Dokud mapa nestojí, je `null`
	   a karty se řídí jen filtrem. */
	let vyrez = null;

	const prosteZobrazeni = () => {
		let vidno = 0;
		for (const c of karty) {
			const ok = !!povolene[c.dataset.i];
			c.classList.toggle('hide', !ok);
			if (ok) vidno++;
		}
		if (synccnt) synccnt.textContent = vidno + ' ' + sklonuj(vidno);
		if (empty) empty.classList.toggle('on', 0 === vidno);
	};

	/*
	 * DEEP LINK SE ZAPISUJE, NE PŘENAČÍTÁ (`replaceState`).
	 *
	 * Adresa musí jít poslat dál a musí přežít reload — proto se po každé
	 * změně přepíše. `replaceState`, ne `pushState`: klepnutí na chip není
	 * navigace a tlačítko Zpět má vrátit na PŘEDCHOZÍ STRÁNKU, ne odklikat
	 * třicet stavů filtru zpátky.
	 *
	 * Ostatní parametry adresy zůstávají (`URLSearchParams` mění jen svůj
	 * klíč) — jinak by se filtrem ztratily UTM značky z reklamy.
	 */
	const zapisAdresu = () => {
		if (!window.history || !window.history.replaceState) return;
		const u = new URL(window.location.href);
		if (vybrane.length) u.searchParams.set('vlastnost', vybrane.join(','));
		else u.searchParams.delete('vlastnost');
		window.history.replaceState(null, '', u.pathname + u.search + u.hash);
	};

	const prekresliChipy = () => {
		for (const b of chipyVlastnosti) {
			const slug = b.dataset.vlastnost || '';
			const je = slug ? vybrane.indexOf(slug) !== -1 : 0 === vybrane.length;
			b.classList.toggle('sel', je);
			b.setAttribute('aria-pressed', String(je));
		}
	};

	const prepocitat = () => {
		const on = {};
		for (const c of chipyTieru) {
			const zaskrtnuto = c.querySelector('input').checked;
			on[c.dataset.std] = zaskrtnuto;
			c.classList.toggle('off', !zaskrtnuto);
		}
		const lim = kapacita && kapacita.value ? parseInt(kapacita.value, 10) : 0;

		/*
		 * PŘÍZNAK „NĚJAKÝ FILTR JE AKTIVNÍ" PRO CSS (19. 9. 2026, bod K).
		 *
		 * Na mobilu podle něj mizí pilulka s počtem a objevuje se „Zrušit
		 * filtr" v rohu mapy. Od dávky 2e se do něj počítají i štítky —
		 * jinak by deep link `?vlastnost=` filtroval, ale zrušit by ho
		 * nešlo. Je to pořád JEDNO místo, kde se podmínka vyhodnocuje;
		 * druhá kopie by se při první změně rozešla. CSS by to samo
		 * nepoznalo (`:has()` je Safari 15.4+, nad naší podlahou 14.1).
		 */
		const filtrAktivni = chipyTieru.some((c) => !c.querySelector('input').checked)
			|| lim > 0
			|| vybrane.length > 0;
		if (rozvrzeni) rozvrzeni.classList.toggle('filtr-aktivni', filtrAktivni);

		/*
		 * VYBRANÉ ŠTÍTKY SE SPOJUJÍ PŘES „A ZÁROVEŇ".
		 * „bazén + hřiště" znamená místo, kde je obojí — tak to čte člověk,
		 * který filtr skládá. Čísla pro OR jsou v REPORT-87.
		 */
		povolene = {};
		let vis = 0;
		for (const c of karty) {
			const cap = parseInt(c.dataset.cap || '0', 10) || 0;
			const moje = stitky(c);
			const ok = !!on[c.dataset.std]
				&& (!lim || cap >= lim)
				&& vybrane.every((v) => moje.indexOf(v) !== -1);
			povolene[c.dataset.i] = ok;
			if (ok) vis++;
		}
		if (mapcnt) mapcnt.textContent = vis;

		prekresliChipy();
		for (const cb of posluchaci) cb(povolene);
		if (vyrez) vyrez(povolene); else prosteZobrazeni();
		zapisAdresu();
	};

	/* Počáteční stav z adresy (deep link i server-side předvýběr archivu). */
	const zAdresy = new URLSearchParams(window.location.search).get('vlastnost') || '';
	const znameSlugy = new Set();
	for (const c of karty) for (const x of stitky(c)) znameSlugy.add(x);
	vybrane = zAdresy.split(',').map((x) => x.trim()).filter((x) => x && znameSlugy.has(x));
	vybrane = [...new Set(vybrane)];

	for (const b of chipyVlastnosti) {
		b.addEventListener('click', () => {
			const slug = b.dataset.vlastnost || '';
			if (!slug) vybrane = [];
			else if (vybrane.indexOf(slug) === -1) vybrane = vybrane.concat([slug]);
			else vybrane = vybrane.filter((x) => x !== slug);
			prepocitat();
		});
	}
	for (const c of chipyTieru) c.querySelector('input').addEventListener('change', prepocitat);
	if (kapacita) kapacita.addEventListener('change', prepocitat);

	const reset = document.getElementById('za-reset');
	if (reset) {
		reset.addEventListener('click', () => {
			for (const c of chipyTieru) c.querySelector('input').checked = true;
			if (kapacita) kapacita.value = '';
			vybrane = [];
			prepocitat();
		});
	}

	/* Panel je v CSS schovaný, dokud na chipech opravdu něco nevisí. */
	if (chipyVlastnosti.length) document.documentElement.classList.add('za-vlfiltr');

	return {
		prepocitat,
		povolene: () => povolene,
		naZmenu: (cb) => posluchaci.push(cb),
		nastavVyrez: (fn) => { vyrez = fn; },
		prosteZobrazeni,
		sklonuj,
	};
}

/**
 * Mapa, filtr a provázání se seznamem. Vrací 1, když se opravdu postavila.
 */
function mapa(data, filtr) {
	const ol = window.ol;
	const cil = document.getElementById('za-map');
	if (!ol || !cil || !filtr || !data || !Array.isArray(data.body) || !data.body.length) return 0;

	const t = data.t || {};
	const sklonuj = filtr.sklonuj;

	const feats = data.body.map((p) => {
		const f = new ol.Feature({ geometry: new ol.geom.Point(ol.proj.fromLonLat([p.lng, p.lat])) });
		f.setProperties({ d: p });
		f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(p.s, false) }) }));
		return f;
	});
	const src = new ol.source.Vector({ features: feats });
	const layer = new ol.layer.Vector({ source: src });

	const map = new ol.Map({
		target: 'za-map',
		controls: [],
		layers: [new ol.layer.Tile({ source: new ol.source.OSM() }), layer],
		view: new ol.View({ center: ol.proj.fromLonLat(data.stred || [15.385296, 49.766626]), zoom: 7, maxZoom: 17, minZoom: 5 }),
	});

	/* Výřez = rozsah všech pinů. Horní odsazení nechává místo plovoucímu filtru. */
	const fitAll = (anim) => {
		const pad = [window.innerWidth > 900 ? 96 : 40, 44, 84, 44];
		map.getView().fit(src.getExtent(), { padding: pad, maxZoom: 9, duration: anim ? 400 : 0 });
	};
	fitAll(false);
	window.addEventListener('resize', () => map.updateSize());

	const zin = document.getElementById('za-zin');
	const zout = document.getElementById('za-zout');
	const zoomout = document.getElementById('za-zoomout');
	if (zin) zin.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() + 1, duration: 220 }));
	if (zout) zout.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() - 1, duration: 220 }));
	if (zoomout) zoomout.addEventListener('click', () => fitAll(true));

	/* Bublina nad pinem. */
	const popEl = document.getElementById('za-pop');
	const overlay = new ol.Overlay({ element: popEl, positioning: 'bottom-center', offset: [0, -46] });
	map.addOverlay(overlay);

	/*
	 * Zvýraznění je párové: pin i dlaždice téhož místa. Návrh měl obojí
	 * připravené, ale nespojené.
	 */
	let horkyPin = null;
	const zhasni = () => {
		if (horkyPin) {
			const d = horkyPin.getProperties().d;
			horkyPin.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(d.s, false) }) }));
			horkyPin = null;
		}
		document.querySelectorAll('.loc.hot').forEach((c) => c.classList.remove('hot'));
	};
	const closePop = () => {
		popEl.classList.remove('on');
		overlay.setPosition(undefined);
		zhasni();
		document.body.classList.remove('karta-lokality');
	};
	/*
	 * KARTA U PINU SE NESMÍ OŘÍZNOUT (bod K7, 19. 9. 2026).
	 *
	 * Nález majitele: „pokud kliknu na pin na okraji mapy v lokalitách,
	 * nesmí se mi karta lokality oříznout, musí se objevit v zorném poli,
	 * nebo se musí posunout i mapa - je mi jedno jak - udělej to správně."
	 *
	 * ---------------------------------------------------------------------
	 * KDE TO BYLO ROZBITÉ (změřeno, ne odhadnuto)
	 * ---------------------------------------------------------------------
	 * NE na mobilu do 767 px: tam je karta přilepená CSS na spodní hranu
	 * přes celou šířku, takže se oříznout nemůže (7/7 pinů u hran a rohů,
	 * přesah 0 px). Rozbité to bylo v pásmu 768–1069 px, kde režim Mapa
	 * existuje, ale mobilní pravidlo karty už ne — a na desktopu svisle:
	 *   · vodorovně až 118 px za pravou hranou mapy,
	 *   · SVISLE až 300 px pod spodní hranou,
	 *   · tlačítko „Detail lokality" v půlce případů neklepnutelné.
	 *
	 * Původní kód měl clamp jen VODOROVNĚ a počítal s natvrdo psanou
	 * poloviční šířkou 146 px (karta má 264, tedy 132) — takže ani ten
	 * vodorovný nevycházel. SVISLE se neřešilo nic; překlopení nad pin
	 * se dělo jen u horní hrany.
	 *
	 * ---------------------------------------------------------------------
	 * PROČ SE POSOUVÁ KARTA, A NE MAPA
	 * ---------------------------------------------------------------------
	 * Majitel nechal způsob na nás. Mapa se posunout NEMŮŽE: na desktopu
	 * je na ní pověšené `map.on('movestart', closePop)`, takže by posun
	 * kartu okamžitě zavřel. Zrušit ten handler kvůli tomu by znamenalo
	 * rozbít chování, které je záměrné (bublina visí na pinu, takže po
	 * odjetí mapy nedává smysl).
	 *
	 * Karta nemá ocásek mířící na pin (ověřeno v CSS), takže posunutá
	 * karta nevypadá rozbitě — jen není přesně nad pinem.
	 *
	 * ---------------------------------------------------------------------
	 * MĚŘÍ SE SKUTEČNOST, NE KONSTANTY
	 * ---------------------------------------------------------------------
	 * Rozměry karty závisí na obsahu (perex, dva až tři údaje) i na šířce
	 * okna, takže žádné číslo v kódu nevydrží. Čte se proto skutečný
	 * `getBoundingClientRect()` a dorovnává se posunem odsazení overlaye.
	 * Dvě kola stačí: první posune, druhé dorovná, když se přitom změnilo
	 * zalomení. Víc kol by byla smyčka bez konce u karty větší než okno.
	 */
	const OKRAJ_KARTY = 8;
	const srovnejKartu = () => {
		/*
		 * Mobilní karta je přilepená CSS (`position: static` uvnitř
		 * kontejneru přes celou šířku). Tam se nesmí sahat — je to
		 * rozhodnutí majitele z bodu K a overlay o jejím umístění nerozhoduje.
		 */
		if ('static' === window.getComputedStyle(popEl).position) return;

		const mr = map.getTargetElement().getBoundingClientRect();
		const okno = {
			l: Math.max(mr.left, 0) + OKRAJ_KARTY,
			t: Math.max(mr.top, 0) + OKRAJ_KARTY,
			r: Math.min(mr.right, document.documentElement.clientWidth) - OKRAJ_KARTY,
			b: Math.min(mr.bottom, document.documentElement.clientHeight) - OKRAJ_KARTY,
		};

		for (let kolo = 0; kolo < 2; kolo++) {
			const pr = popEl.getBoundingClientRect();
			let dx = 0;
			let dy = 0;
			if (pr.right > okno.r) dx = okno.r - pr.right;
			if (pr.left + dx < okno.l) dx = okno.l - pr.left;
			if (pr.bottom > okno.b) dy = okno.b - pr.bottom;
			/* Horní hrana má přednost: uříznutý spodek jde dorolovat uvnitř
			   karty, uříznutý vršek znamená, že není vidět název. */
			if (pr.top + dy < okno.t) dy = okno.t - pr.top;
			if (!dx && !dy) return;
			const off = overlay.getOffset();
			overlay.setOffset([off[0] + dx, off[1] + dy]);
		}
	};

	const openPop = (f) => {
		const d = f.getProperties().d;
		/*
		 * Obsah bubliny se skládá z uzlů, ne z řetězce. Název lokality
		 * je uživatelský obsah a `innerHTML` by z uvozovky v názvu
		 * udělalo rozbitý atribut — nebo horší.
		 */
		popEl.textContent = '';
		const zavri = document.createElement('button');
		zavri.className = 'px';
		zavri.type = 'button';
		zavri.setAttribute('aria-label', t.zavrit || 'Zavřít');
		zavri.textContent = '×';
		zavri.addEventListener('click', closePop);
		popEl.appendChild(zavri);
		if (d.img) {
			const img = document.createElement('img');
			img.src = d.img;
			img.alt = d.t;
			popEl.appendChild(img);
		}
		const pb = document.createElement('div');
		pb.className = 'pb';
		const b = document.createElement('b');
		b.textContent = d.t;
		pb.appendChild(b);
		/*
		 * Perex lokality (nález P2). Kentická bublina ho měla jako
		 * `data-subname` pod názvem; nová ho do 17. 9. ztratila — byl to
		 * jediný věcný údaj, který se z šestnácti legacy `data-*` nepřenesl.
		 * Text je uživatelský obsah, proto `textContent`, ne `innerHTML`.
		 */
		if (d.p) {
			const perex = document.createElement('p');
			perex.className = 'pp';
			perex.textContent = d.p;
			pb.appendChild(perex);
		}
		const pm = document.createElement('div');
		pm.className = 'pm';
		for (const txt of [d.c, d.cap]) {
			if (!txt) continue;
			const s = document.createElement('span');
			s.textContent = txt;
			pm.appendChild(s);
		}
		pb.appendChild(pm);
		const go = document.createElement('a');
		go.className = 'pgo';
		go.href = d.u;
		go.textContent = t.detail || 'Detail';
		pb.appendChild(go);
		popEl.appendChild(pb);

		/*
		 * Bublina se drží uvnitř mapy: nad pinem, nebo pod ním u horní hrany.
		 * Hrubé umístění; přesné dorovnání dělá `srovnejKartu()` níž.
		 */
		const coord = f.getGeometry().getCoordinates();
		const pix = map.getPixelFromCoordinate(coord);
		if (pix[1] < 250) { overlay.setPositioning('top-center'); overlay.setOffset([0, 10]); }
		else { overlay.setPositioning('bottom-center'); overlay.setOffset([0, -46]); }
		overlay.setPosition(coord);
		popEl.classList.add('on');
		srovnejKartu();
		document.body.classList.add('karta-lokality');

		zhasni();
		horkyPin = f;
		f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(d.s, true) }) }));
		const karta = document.querySelector('.loc[data-i="' + d.i + '"]');
		if (karta && karta.offsetParent) karta.scrollIntoView({ block: 'center', behavior: 'smooth' });
		else if (karta) karta.classList.add('hot');
		if (karta) karta.classList.add('hot');
	};
	map.on('singleclick', (e) => {
		const hit = map.forEachFeatureAtPixel(e.pixel, (f) => f);
		if (hit) openPop(hit); else closePop();
	});
	map.on('pointermove', (e) => {
		map.getTargetElement().style.cursor = map.hasFeatureAtPixel(e.pixel) ? 'pointer' : '';
	});

	/*
	 * ROLE MAPY VE FILTRU (dávka 2e): mapa už filtr NEVLASTNÍ.
	 *
	 * Stroj `filtrVypisu()` spočítá z karet, co je povolené, a zavolá
	 * sem dvě věci: překreslení pinů a — na desktopu — zúžení seznamu
	 * podle výřezu. Mapa tedy nic nerozhoduje, jen kreslí.
	 */
	const karty = {};
	document.querySelectorAll('.loc').forEach((c) => { karty[c.dataset.i] = c; });
	const synccnt = document.getElementById('za-synccnt');
	const empty = document.getElementById('za-empty');
	const podleIndexu = {};
	feats.forEach((f) => { podleIndexu[f.getProperties().d.i] = f; });

	/*
	 * Na mobilu jsou seznam a mapa dva oddělené režimy. Výřez mapy
	 * tedy nesmí výpis omezovat: v režimu seznamu mapa žádné rozměry
	 * nemá a `calculateExtent` by schoval úplně všechno.
	 */
	const syncList = (povolene) => {
		povolene = povolene || filtr.povolene();
		if (jeMobil()) {
			filtr.prosteZobrazeni();
			return;
		}
		const extent = map.getView().calculateExtent(map.getSize());
		let inView = 0;
		let shown = 0;
		for (const k of Object.keys(karty)) {
			const c = karty[k];
			if (!povolene[k]) { c.classList.add('hide'); continue; }
			const f = podleIndexu[k];
			/*
			 * KARTA BEZ PINU JE VIDĚT (oprava tiché vady, dávka 2e).
			 * Lokalita bez souřadnic žádný pin nemá, takže se o ní nedá
			 * říct, že je „mimo výřez". Do 19. 9. ji filtr schovával
			 * vždycky; na DEV je dnes takových 0 z 85, takže to nebylo
			 * vidět — ale první lokalita bez souřadnic by z výpisu tiše
			 * zmizela.
			 */
			if (!f) { c.classList.remove('hide'); inView++; shown++; continue; }
			if (ol.extent.containsCoordinate(extent, f.getGeometry().getCoordinates())) {
				inView++; c.classList.remove('hide'); shown++;
			} else { c.classList.add('hide'); }
		}
		if (synccnt) synccnt.textContent = inView + ' ' + sklonuj(inView);
		if (empty) empty.classList.toggle('on', 0 === shown);
	};

	/*
	 * Popisek čítače platí jen tam, kde výpis stojí vedle mapy.
	 * Na mobilu se čítač vztahuje k filtru, ne k výřezu.
	 */
	const popisekCitace = () => {
		const l = document.querySelector('.sylab');
		if (l) l.textContent = jeMobil() ? (t.zobrazeno || 'Zobrazeno:') : (t.ve_vyrezu || 'Ve výřezu mapy:');
	};
	let prahBylMobil = jeMobil();
	let tikResize;
	window.addEventListener('resize', () => {
		clearTimeout(tikResize);
		tikResize = setTimeout(() => {
			if (jeMobil() !== prahBylMobil) { prahBylMobil = jeMobil(); popisekCitace(); }
			syncList();
		}, 150);
	});

	/* Piny podle stavu filtru + zavření bubliny, která by ukazovala na skrytý pin. */
	filtr.naZmenu((povolene) => {
		feats.forEach((f) => {
			const d = f.getProperties().d;
			f.setStyle(povolene[d.i]
				? new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(d.s, false) }) })
				: new ol.style.Style(null));
		});
		closePop();
	});
	filtr.nastavVyrez(syncList);

	/*
	 * Bublina na desktopu visí na pinu, takže po odjetí mapy nedává smysl.
	 * Mobilní karta je zaražená do spodní hrany a s mapou se nehýbe.
	 */
	map.on('movestart', () => { if (!jeMobil()) closePop(); });
	map.on('moveend', () => syncList());
	popisekCitace();
	/* Mapa vznikla později než stav filtru — přepočet ji rovnou srovná. */
	filtr.prepocitat();

	/* Najetí na dlaždici zvýrazní pin. */
	document.querySelectorAll('.loc').forEach((c) => {
		const f = podleIndexu[c.dataset.i];
		if (!f) return;
		const d = f.getProperties().d;
		c.addEventListener('mouseenter', () => {
			if (!filtr.povolene()[d.i]) return;
			f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(d.s, true), scale: 1.18 }) }));
		});
		c.addEventListener('mouseleave', () => {
			if (!filtr.povolene()[d.i]) return;
			f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(d.s, false) }) }));
		});
	});

	return { map, fitAll };
}

/** Přepínač šířky výpisu (dva sloupce / větší mapa). */
function prepinacSirky(stav) {
	const box = document.getElementById('za-locview');
	const lay = document.querySelector('.loclayout');
	if (!box || !lay) return 0;
	box.addEventListener('click', (e) => {
		const b = e.target.closest('button[data-mapbig]');
		if (!b) return;
		const velka = '1' === b.dataset.mapbig;
		lay.classList.toggle('mapbig', velka);
		box.querySelectorAll('button').forEach((x) => {
			x.setAttribute('aria-pressed', String(('1' === x.dataset.mapbig) === velka));
		});
		// Mapa po změně šířky potřebuje překreslit, jinak zůstane v původním rámu.
		if (stav.map) setTimeout(() => stav.map.updateSize(), 260);
	});
	return 1;
}

/**
 * Přepínač Seznam / Mapa a LÍNÝ START MAPY NA MOBILU.
 *
 * Rozhodnutí kontraktu §2: na mobilu se mapa staví až na klepnutí.
 * Do té doby se OpenLayers vůbec nespustí.
 */
function prepinacRezimu(stav, postavMapu) {
	const t = document.querySelector('.mtabs');
	if (!t) return 0;
	t.addEventListener('click', (e) => {
		const b = e.target.closest('button[role="tab"]');
		if (!b) return;
		const mapa2 = 'za-tab-mapa' === b.id;
		document.body.classList.toggle('zobraz-mapu', mapa2);

		/*
		 * TÁŽ TŘÍDA JEŠTĚ NA `<html>` — kvůli legacy pravidlu, na které
		 * z `<body>` nedosáhne žádný selektor.
		 *
		 * Rozhodnutí majitele 19. 9. 2026: režim Mapa má na mobilu být
		 * „opravdu jen mapa", tedy bez rolování. Jenže mirrorovaný
		 * `main.css` má `html, body { height: 100%; min-height: 1200px }`,
		 * takže dokument je vždy aspoň 1 200 px vysoký a stránka jde
		 * odrolovat o 356 px, i když pod mapou nic není (doměřeno na
		 * 390 px). Roluje `<html>`, ne `<body>` — `overflow: hidden`
		 * na `<body>` s tím proto nic neudělá.
		 *
		 * CSS rodiče vybrat neumí (`:has()` je Safari 15.4+, nad naší
		 * podlahou 14.1), takže třídu musí nasadit skript. Neutralizaci
		 * pak drží `html.zobraz-mapu` v `components.css`, v bloku
		 * pro ≤767 px — na desktopu se nic nemění.
		 */
		document.documentElement.classList.toggle('zobraz-mapu', mapa2);
		t.querySelectorAll('button').forEach((x) => {
			x.setAttribute('aria-selected', String(('za-tab-mapa' === x.id) === mapa2));
		});
		if (!mapa2) return;

		if (!stav.map) postavMapu();

		/*
		 * Bez posunu by mapa začínala až pod herem a karta u pinu,
		 * která dosedá na spodní okraj, by zůstala pod okrajem obrazovky.
		 */
		const y = t.getBoundingClientRect().top + window.pageYOffset - 60;
		if (window.pageYOffset < y) window.scrollTo({ top: y, behavior: 'smooth' });
		if (stav.map) {
			setTimeout(() => {
				stav.map.updateSize();
				// Mapa se inicializovala ve skrytém prvku a nese si zoom z jiného rámu.
				if (stav.fitAll) stav.fitAll(false);
			}, 260);
		}
	});
	return 1;
}

/**
 * Vstupní bod. Vrací počet inicializací (posuvníky + mapa + přepínače).
 */
export function init() {
	const layout = document.querySelector('.loclayout');
	if (!layout) return 0;

	let pocet = 0;
	document.querySelectorAll('.loc').forEach((c) => { pocet += slider(c); });

	const data = window.ZA2026_LOKALITY || null;

	/*
	 * FILTR PRVNÍ, MAPA AŽ POTOM (dávka 2e).
	 *
	 * Stav musí existovat dřív, než se mapa vůbec rozhodne, jestli se
	 * postaví: na mobilu se staví až na klepnutí na „Mapa", ale deep
	 * link `?vlastnost=bazen` má filtrovat hned po načtení. Bez mapy
	 * stroj karty prostě skryje a schová; s mapou navíc překreslí piny.
	 */
	const filtr = filtrVypisu((data && data.t) || {});
	if (filtr) { filtr.prepocitat(); pocet += 1; }

	const stav = { map: null, fitAll: null };
	const postavMapu = () => {
		const r = mapa(data, filtr);
		if (r) { stav.map = r.map; stav.fitAll = r.fitAll; pocet += 1; }
	};

	// Na mobilu až na klepnutí (viz hlavička souboru).
	if (!jeMobil()) postavMapu();

	pocet += prepinacSirky(stav);
	pocet += prepinacRezimu(stav, postavMapu);
	return pocet;
}

/**
 * Galerie na detailu lokality: posuv, tečky, počítadlo.
 *
 * Zvětšení NEŘEŠÍ — slide je `<a class="zoomable">` a překryv obsluhuje
 * `lightbox.js`. Dva moduly nad jedním prvkem by se prali o klik.
 */
function detailGalerie() {
	const gal = document.querySelector('.lgal');
	if (!gal) return 0;
	const track = gal.querySelector('.lgalslides');
	if (!track) return 0;
	const n = track.children.length;
	const count = gal.querySelector('.lgalcount');
	const dots = [...gal.querySelectorAll('.lgaldots button')];
	if (n < 2) {
		gal.classList.add('single');
		return 1;
	}
	let i = 0;
	const go = (k) => {
		i = (k + n) % n;
		track.style.transform = 'translateX(' + (-i * 100) + '%)';
		dots.forEach((d, j) => d.classList.toggle('on', j === i));
		if (count) count.textContent = (i + 1) + ' / ' + n;
	};
	const prev = gal.querySelector('.lgalarr.prev');
	const next = gal.querySelector('.lgalarr.next');
	if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); go(i - 1); });
	if (next) next.addEventListener('click', (e) => { e.preventDefault(); go(i + 1); });
	dots.forEach((d, j) => d.addEventListener('click', (e) => { e.preventDefault(); go(j); }));
	go(0);
	return 1;
}

/**
 * Mapa s jedním pinem na detailu lokality.
 *
 * Bez knihovny `ol` nebo bez souřadnic se nestaví vůbec — prázdný šedý
 * obdélník je horší než karta s adresou, která zůstane sama.
 */
function detailMapa() {
	const ol = window.ol;
	const cil = document.getElementById('za-map-detail');
	const data = window.ZA2026_LOKALITA || null;
	if (!ol || !cil || !data || 'number' !== typeof data.lat) return 0;

	const f = new ol.Feature({ geometry: new ol.geom.Point(ol.proj.fromLonLat([data.lng, data.lat])) });
	f.setStyle(new ol.style.Style({ image: new ol.style.Icon({ anchor: [0.5, 1], src: pinIcon(data.s, false) }) }));
	const src = new ol.source.Vector({ features: [f] });

	const map = new ol.Map({
		target: 'za-map-detail',
		controls: [],
		layers: [new ol.layer.Tile({ source: new ol.source.OSM() }), new ol.layer.Vector({ source: src })],
		view: new ol.View({ center: ol.proj.fromLonLat([data.lng, data.lat]), zoom: data.zoom || 13, maxZoom: 18, minZoom: 5 }),
	});
	window.addEventListener('resize', () => map.updateSize());

	const zin = document.getElementById('za-zin-detail');
	const zout = document.getElementById('za-zout-detail');
	if (zin) zin.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() + 1, duration: 220 }));
	if (zout) zout.addEventListener('click', () => map.getView().animate({ zoom: map.getView().getZoom() - 1, duration: 220 }));
	return 1;
}

/**
 * Tlačítko „Načíst další" u doporučených akcí.
 *
 * Parita ukazuje první tři a zbytek odkrývá třídou `open` na kontejneru.
 * Tady je totéž, jen bez jQuery: dlaždice nad limit dostanou `hide`
 * a tlačítko je odkryje. Bez skriptu jsou vidět VŠECHNY — nikdy ne míň,
 * než kolik jich parita nakonec ukáže.
 */
function relatedVic() {
	const box = document.querySelector('.related');
	if (!box) return 0;
	const btn = box.querySelector('.more button');
	const karty = [...box.querySelectorAll('.grid3 > *')];
	if (!btn || karty.length <= 3) return 0;
	karty.slice(3).forEach((c) => c.classList.add('hide'));
	btn.hidden = false;
	/*
	 * Po odkrytí musí být poznat, CO se odkrylo: fokus jde na první
	 * nově zobrazenou dlaždici a čtečka dostane hlášku. Bez toho
	 * zůstane fokus na tlačítku, které zmizí, a fokus spadne na
	 * `<body>` — člověk u klávesnice se ocitne na začátku stránky.
	 */
	btn.addEventListener('click', () => {
		const nove = karty.slice(3);
		karty.forEach((c) => c.classList.remove('hide'));
		const hlaska = document.createElement('p');
		hlaska.className = 'srhint';
		hlaska.setAttribute('role', 'status');
		hlaska.setAttribute('aria-live', 'polite');
		hlaska.textContent = btn.dataset.hotovo || '';
		btn.closest('.more').replaceWith(hlaska);
		const cil = nove[0];
		if (cil) {
			cil.setAttribute('tabindex', '-1');
			cil.focus({ preventScroll: true });
		}
	});
	return 1;
}

/**
 * Detail lokality. Oddělený vstupní bod od výpisu: obě stránky sdílí
 * knihovnu a kreslení pinu, ale nic víc.
 */
export function initDetail() {
	if (!document.querySelector('.lhero')) return 0;
	return detailGalerie() + detailMapa() + relatedVic();
}

/**
 * Odkrývání dalších výsledků vyhledávání (`.shmore button`).
 *
 * Skrytý blok je v HTML s atributem `hidden`, ne `display:none` z CSS:
 * bez skriptu by se nedal odkrýt vůbec, a tak se tlačítko bez skriptu
 * ani nevypisuje (šablona ho tiskne jen když je co odkrývat, a odkrytí
 * dělá jen tohle).
 *
 * Vrací počet obsloužených tlačítek.
 */
export function initHledani() {
	const tlacitka = [...document.querySelectorAll('.shmore button[data-vic]')];
	if (!tlacitka.length) return 0;
	for (const b of tlacitka) {
		b.addEventListener('click', () => {
			const cil = document.getElementById(b.dataset.vic);
			if (!cil) return;
			cil.hidden = false;
			b.setAttribute('aria-expanded', 'true');
			b.closest('.shmore').remove();
		});
	}
	return tlacitka.length;
}
